module.exports = __webpack_public_path__ + "img/mote-50 1 (1).b9dd849d.png";